module.exports = __webpack_public_path__ + "static/media/followed.d2ef3a56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/followed.svg
// module id = 905
// module chunks = 1